import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookiesPopupComponent } from './cookies-popup.component';
import { MatButtonModule } from '@angular/material/button';

const ANGULAR_MATERIAL_MODULES = [
  MatButtonModule
];

@NgModule({
  declarations: [CookiesPopupComponent],
  exports: [CookiesPopupComponent],
  imports: [CommonModule, ...ANGULAR_MATERIAL_MODULES]
})
export class CookiesPopupModule { }
